export { Matching } from "./matching";
export type {
  MatchingProps,
  TAutoScrollOptions,
  TMatch,
  TMatchStyles,
} from "./matching";
